<template>
  <v-container fluid>
    <v-row class="mx-4 mt-4">
      <v-col lg="8">
        <h2 class="text-h5 mb-2" style="color: #ca0538">
          REFERENCES DU SITE INTERNET
        </h2>
        <p class="text-justify">
          Le site internet ''Base de données substances réglementées WEB : BDSR
          Web'' est édité par : <br />
          Le Centre Technique des Industries Mécanique (CETIM),
          <br />Etablissement de droit privé reconnu d’utilité publique régi par
          les articles L521.1 à L521.13 du code de la recherche relatifs aux
          Centres Techniques Industriels, immatriculée au registre SIREN sous le
          numéro 775629074. <br />
          Siège social : Senlis (60304) – BP 80067 – 52, avenue Félix Louât
          Numéro de TVA intracommunautaire : FR 18 775 629 074
        </p>
        <p class="text-justify">
          Responsable de publication : Daniel RICHET, Directeur Général
          Hébergeur : Le site est hébergé par le CETIM
        </p>
        <h2 class="text-h5 mb-2" style="color: #ca0538">REGLES DE DIFFUSION</h2>
        <p class="text-justify">
          Le présent site internet BDSR WEB est la propriété du CETIM (Centre
          technique des industries mécaniques) dont la direction générale est
          située 52, avenue Félix Louât, à Senlis (60). L'Utilisateur reconnaît
          utiliser ces informations sous sa responsabilité exclusive. Le site
          internet « Base de données substances réglementées WEB : BDSR WEB »
          est normalement accessible 24h/24h et 7 jours/7. En cas de force
          majeure, de difficultés informatiques, de difficultés liées à la
          structure des réseaux de télécommunications ou difficultés techniques,
          pour des raisons de maintenance, sans que cette liste ne soit
          exhaustive, l'accès à tout ou partie du site pourra être suspendu ou
          interrompu sur simple décision du CETIM. <br />
          Le site internet BDSR
        </p>
        <p class="text-justify">
          WEB est susceptible de modification et d'évolutions sans notification
          préalable d'aucune sorte.
        </p>
        <h2 class="text-h5 mb-2" style="color: #ca0538">
          CONDITIONS GENERALES D’UTILISATION - CGU
        </h2>
        <h3>ARTICLE 1 : CONDITIONS GENERALES D’ACCES</h3>
        <p class="text-justify">
          Le site internet ''Base de données substances réglementées WEB : BDSR
          WEB'', ci-après dénommé le site internet BDSR WEB, met à la
          disposition des Utilisateurs les informations suivantes :
        </p>
        <ul>
          <li>
            Des textes applicables aux industries mécaniciennes réglementant des
            substances
          </li>
          <li>Les substances visées dans ces réglementations</li>
          <li>Les exigences réglementaires de chacun des textes</li>
          <li>
            Des utilisations potentielles des substances identifiées pour le
            secteur de la mécanique et non exhaustives. D’une formulation ou
            d’un fabricant à l’autre, les utilisations peuvent variées.
          </li>
        </ul>
        <br />
        <p class="text-justify">
          Le site internet BRSR est accessible gratuitement en tout lieu à tout
          Utilisateur ayant un accès internet. Tous les frais supportés par
          l’Utilisateur pour accéder au service (matériel informatique,
          logiciels, connexion Internet, etc.) sont à sa seule charge. L’accès
          au site internet BDSR WEB requiert l’utilisation d’un compte
          ressortissant du Cetim.
        </p>
        <p class="text-justify">
          L’accès à certaines données Utilisateurs requiert le consentement de
          l’Utilisateur. L’Utilisateur non ressortissant du Cetim n’a pas accès
          aux services réservés. Pour accéder au site, s’il ne possède pas déjà
          un compte sur le site internet du Cetim, l’Utilisateur devra en créer
          un via le lien disponible sur le site internet du Cetim. Après
          vérification par les services du Cetim de son statut de ressortissant,
          il acquerra les droits d’accès sans réserve site internet BDSR WEB.
          <br />
          En acceptant de s’inscrire aux services réservés, l’Utilisateur
          ressortissant s’engage à fournir des informations sincères et exactes
          concernant son état civil et ses coordonnées, notamment son adresse
          email professionnel.
        </p>
        <p class="text-justify">
          Pour accéder aux services, l’Utilisateur doit ensuite s’identifier à
          l’aide de son identifiant et de son mot de passe qu’il aura choisis
          lors de son inscription. Tout Utilisateur ressortissant Cetim
          régulièrement inscrit pourra également solliciter sa désinscription en
          se rendant à la page dédiée sur son espace personnel. Celle-ci sera
          effective dans un délai raisonnable.
        </p>
        <p class="text-justify">
          Tout événement dû à un cas de force majeure ayant pour conséquence un
          dysfonctionnement du site internet BDSR ou du serveur et sous réserve
          de toute interruption ou modification en cas de maintenance, n’engage
          pas la responsabilité du Cetim. Dans ces cas, l’Utilisateur accepte
          ainsi ne pas tenir rigueur à l’éditeur de toute interruption ou
          suspension de service, même sans préavis. L’Utilisateur a la
          possibilité de contacter le site par messagerie électronique à
          l’adresse e-mail de l’éditeur communiqué en Informations légales.
        </p>
        <h3>ARTICLE 2 : COLLECTE DES DONNEES</h3>
        <p class="text-justify">
          Le site internet BDSR WEB assure à l’Utilisateur une collecte et un
          traitement d’informations personnelles dans le respect de la vie
          privée conformément à la loi n°78-17 du 6 janvier 1978 modifiée
          relative à l’informatique, aux fichiers et aux libertés. En vertu de
          la loi Informatique et Libertés, en date du 6 janvier 1978,
          l’Utilisateur dispose d’un droit d’accès, de rectification, de
          suppression et d’opposition de ses données personnelles tel que
          mentionné en « Données Personnelles ».
        </p>
        <h3>ARTICLE 3 : PROPRIETE INTELLECTUELLE</h3>
        <p class="text-justify">
          Les marques, logos, signes ainsi que tous les contenus du site
          (textes, images, son…) font l’objet d’une protection par le Code de la
          propriété intellectuelle et plus particulièrement par le droit
          d’auteur. La marque Cetim est protégée. Toute représentation et/ou
          reproduction et/ou exploitation partielle ou totale de cette marque,
          de quelque nature que ce soit, est totalement prohibée.
        </p>
        <p class="text-justify">
          En application du Code français de la Propriété Intellectuelle et,
          plus généralement, des traités et accords internationaux comportant
          des dispositions relatives à la protection des droits d'auteurs, toute
          reproduction pour un usage autre que privé, soit la vente, la
          distribution, l’émission, la diffusion, l’adaptation, la modification,
          la publication, ou la communication qu’elle soit intégrale ou
          partielle, sous quelque forme que ce soit, des données, de la
          présentation ou de l'organisation du site internet BDSR ou d’œuvres
          protégées par le droit d'auteur qui figurent sur le site internet
          BDSR, sans autorisation écrite particulière et préalable du détenteur
          du droit d'auteur attaché à l'œuvre, à la présentation ou à
          l'organisation du site internet BDSR ou à la donnée reproduite, est
          strictement interdite. Il est également interdit d'introduire des
          données le site internet BDSR qui modifieraient ou qui seraient
          susceptibles de modifier le contenu ou l'apparence des données, de la
          présentation ou de l'organisation de celle-ci ou des œuvres figurant
          sur celle-ci quelle qu’en soit le procédé.
        </p>
        <p class="text-justify">
          L’Utilisateur doit solliciter l’autorisation préalable du site
          internet BDSR pour toute reproduction, publication, copie des
          différents contenus. Il s’engage à une utilisation des contenus du
          site internet BDSR dans un cadre strictement privé, toute utilisation
          à des fins commerciales et publicitaires est strictement interdite.
        </p>
        <h3>ARTICLE 4 : RESPONSABILITE</h3>
        <p class="text-justify">
          Les sources des informations diffusées sur le site internet BDSR «
          BDSR WEB » sont réputées fiables mais le site internet BDSR Web ne
          garantit pas qu’il soit exempt de défauts, d’erreurs ou d’omissions.
          Les informations communiquées sont présentées à titre indicatif et
          général sans valeur contractuelle. Malgré des mises à jour régulières,
          le site internet BDSR ne peut être tenu responsable de la modification
          des dispositions administratives et juridiques survenant après la
          publication. De même, le site ne peut être tenu responsable de
          l’utilisation et de l’interprétation de l’information Le Cetim n'est
          tenu que d'une simple obligation de moyens concernant lesdites
          informations qu’il met à disposition des personnes qui accèdent au
          site internet BDSR Web.
        </p>
        <p class="text-justify">
          Le Cetim ne peut encourir aucune responsabilité du fait d'erreurs,
          d'omissions, ou pour les résultats qui pourraient être obtenus par
          l'usage de ces informations, y compris d’éventuels virus qui
          pourraient infecter l’ordinateur ou tout matériel informatique de
          l’Utilisateur, suite à une utilisation, à l’accès, ou au
          téléchargement provenant du site internet BDSR Web. L’Utilisateur
          s’assure de garder son mot de passe secret. Toute divulgation du mot
          de passe, quelle que soit sa forme, est interdite. Il assume les
          risques liés à l’utilisation de son identifiant et mot de passe. Le
          site internet BDSR Web décline toute responsabilité. La responsabilité
          du site internet BDSR WEB ne peut être engagée en cas de force majeure
          ou du fait imprévisible et insurmontable d’un tiers.
        </p>
        <h3>ARTICLE 5 : LIENS HYPERTEXTES</h3>
        <p class="text-justify">
          Des liens hypertextes peuvent être présents dans le site internet BDSR
          Web. L’Utilisateur est informé qu’en cliquant sur ces liens, il
          sortira du site internet BDSR Web. Ce dernier n’a pas de contrôle sur
          la destination à laquelle ces liens aboutissent et ne saurait, en
          aucun cas, être responsable de leur contenu.
        </p>
        <h3>ARTICLE 6 : COOKIES</h3>
        <p class="text-justify">
          L’Utilisateur est informé que lors de ses visites dans le site
          internet BDSR Web, un cookie peut s’installer automatiquement sur son
          logiciel de navigation. Les cookies sont de petits fichiers stockés
          temporairement sur le disque dur de l’ordinateur de l’Utilisateur par
          son navigateur et nécessaires à l’utilisation du site internet BDSR
          Web. Les cookies ne contiennent pas d’information personnelle et ne
          peuvent pas être utilisés pour identifier quelqu’un. Un cookie
          contient un identifiant unique, généré aléatoirement et donc anonyme.
          Certains cookies expirent à la fin de la visite de l’Utilisateur,
          d’autres restent. L’information contenue dans les cookies pourra être
          utilisée pour améliorer ou optimiser l’utilisation du site internet
          BDSR Web.
        </p>
        <p class="text-justify">
          En naviguant sur le site internet BDSR Web, l’Utilisateur les accepte.
          L’Utilisateur doit toutefois donner son consentement quant à
          l’utilisation de certains cookies. A défaut d’acceptation,
          l’Utilisateur est informé que certaines fonctionnalités ou pages
          risquent de lui être refusées. L’Utilisateur pourra désactiver ces
          cookies par l’intermédiaire des paramètres figurant au sein de son
          navigateur internet.
        </p>
        <h3>ARTICLE 7 : DROIT APPLICABLE ET JURIDICTION COMPETENTE</h3>
        <p class="text-justify">
          La législation française s’applique au présent contrat. En cas
          d’absence de résolution amiable d’un litige né entre les parties, les
          tribunaux de Paris, France, seront seuls compétents pour en connaître.
        </p>
        <p class="text-justify">
          Pour toute question relative à l’application des présentes CGU, vous
          pouvez joindre l’éditeur.
        </p>
        <h2 class="text-h5 mb-2" style="color: #ca0538">
          DONNEES PERSONNELLES
        </h2>
        <h4>Politique de protection des données personnelles</h4>
        <p class="text-justify">
          La présente politique définit la façon dont le Cetim répond à ses
          obligations concernant le traitement des données personnelles de
          l’Utilisateur qu’il pourrait collecter dans le cadre de ses missions
          statutaires et les droits dont dispose l’Utilisateur en vertu de la
          réglementation nationale et communautaire sur les données
          personnelles.
        </p>
        <h4>
          Information sur la protection des données à caractère personnel (RGPD)
        </h4>
        <p class="text-justify">
          Le Cetim est engagé dans une démarche de protection des données à
          caractère personnel qu’il traite. Pour les besoins de ses activités,
          le Cetim est amené à traiter des données à caractère personnel. La
          notion de « données à caractère personnel » vise toute information se
          rapportant à une personne physique identifiée ou pouvant être
          identifiée, directement ou indirectement, par un ou plusieurs éléments
          spécifiques propres à son identité physique, physiologique, génétique,
          psychique, économique, culturelle ou sociale. A ce titre le Cetim
          s’engage à respecter le Règlement général sur la protection des
          données 2016/679 du 27 avril 2016 (« RGPD ») et la loi n°78-17 du 6
          janvier 1978 modifiée relative à l’informatique, aux fichiers et aux
          libertés.
        </p>
        <p class="text-justify">
          Ce document décrit comment le Cetim collecte, utilise et gère des
          données à caractère personnel, ainsi que les droits des personnes
          concernées.
        </p>
        <h4>
          Quels types de données à caractère personnel concernant l’Utilisateur
          le Cetim collecte-t-il ?
        </h4>
        <p class="text-justify">
          Selon les circonstances et sous réserve que l’Utilisateur ait consenti
          à la collecte de données, le Cetim est amené à collecter certaines des
          données à caractère personnel listées ci-dessous :
        </p>
        <ul>
          <li>Information d’identité ; nom, prénom, civilité</li>
          <li>
            Informations de contact : coordonnées professionnelles (adresse
            postale, adresse de livraison, de facturation, téléphone, adresse
            email professionnelle)
          </li>
          <li>
            Données de connexion liées à la navigation sur les sites internet du
            Cetim
          </li>
          <li>
            Données nécessaires à l’exécution des contrats conclus par le Cetim
            dans le cadre de ses activités collectives, marchandes, etc….
          </li>
          <li>
            Données nécessaires à la gestion des relations évènementielles,
            opérations de communication, sollicitation, promotion,
            investissement, mécénat et partenariat
          </li>
        </ul>
        <br />
        <p class="text-justify">
          Le Cetim ne collecte et ne traite aucunes données dites « sensibles »
          ou « à risque » au sens du Règlement Général de Protection des
          Données.
        </p>
        <h4>Données collectées à l'occasion de la consultation du site</h4>
        <p class="text-justify">
          Le Cetim est amené à demander à l’Utilisateur un certain nombre de
          données pour organiser au mieux les relations commerciales et le
          service attendu : société, nom, adresse de livraison et de
          facturation, adresse e-mail professionnelle.
        </p>
        <p class="text-justify">
          Certaines données sont indispensables au traitement d’une demande ou
          d’une commande de l’Utilisateur. D'autres permettent de mieux
          connaître l’Utilisateur et donc d’adapter les offres du Cetim aux
          besoins effectifs. Sur les pages où des données à caractère personnel
          sont demandées, l’Utilisateur sera informé du caractère obligatoire
          (signalé par le symbole *) ou facultatif de leur transmission, dans le
          respect de la réglementation sur la protection des données
          personnelles des personnes physiques.
        </p>
        <h4>
          Pour quelles raisons et dans quel but le CETIM collecte-t-il les
          données Utilisateur à caractère personnel ?
        </h4>
        <p class="text-justify">
          Le Cetim peut être amené à collecter des données à caractère
          personnel, en qualité de responsable de traitement, pour répondre aux
          demandes, pour le respect de ses obligations légales et
          conventionnelles, l’exécution d’un contrat, pour des motifs d’intérêts
          publics ou pour la réalisation d’un intérêt légitime. Le Cetim
          collecte des données à caractère personnel, le cas échéant par le
          biais de formulaires et pages de contact, notamment aux fins de
          traitement d’une inscription en ligne, d’un abonnement à des
          newsletters ou à des publications, de réponse à une demande
          d’information via notre Service Questions réponses (SQR), d’études
          statistiques, enquêtes et sondages, à l’occasion de votre consultation
          de sites internet, ou à des fins Page 8 sur 12 d’action de
          communication interne ou externe telles que la gestion d’évènements et
          l’organisation de sessions de formation, conférence, ainsi que l’envoi
          d’informations relatives aux activités du Cetim. Dès lors que vous
          êtes devenu client de notre organisme, nous serons susceptibles de
          vous adresser nos offres commerciales par tout moyen, dont la
          messagerie électronique, dès lors qu'elles nous sembleront de nature à
          vous intéresser. Dans nos envois par e-mail, nous précisons clairement
          dans l'objet du message, qui apparaît dans la boîte aux lettres
          électronique, l'identité, ou la nature commerciale de notre
          proposition. En pied de message, vous trouvez également la possibilité
          d'exercer votre droit d'opposition à l'envoi de tout nouveau message.
        </p>
        <h4>Quels sont vos droits sur vos données à caractère personnel ?</h4>
        <p class="text-justify">
          En vertu du RGPD, les personnes concernées disposent de plusieurs
          droits. Si vous souhaitez les exercer ou obtenir des informations
          complémentaires à ce sujet, vous pouvez contacter le Cetim. Vous
          trouverez toutes les informations nécessaires au paragraphe nommé «
          Délégué à la protection des données ». Les droits des personnes
          concernées comprennent en particulier :
        </p>
        <ul>
          <li>
            Le droit d'information : vous pouvez vous faire confirmer
            conformément à l’art. 15 du RGPD que les données à caractère
            personnel concernées font ou non l’objet d’un traitement par nos
            soins. Si les données font l’objet d’un traitement, vous pouvez
            aussi obtenir de nous des informations complémentaires sur le
            traitement.
          </li>
          <li>
            Le droit de rectification : conformément à l‘art. 16 du RGPD, vous
            avez un droit de rectifier et/ou de compléter les données à
            caractère personnel traitées vous concernant si celles-ci sont
            erronées ou incomplètes.
          </li>
          <li>
            Le droit à la limitation du traitement : dans certaines conditions,
            vous pouvez exiger conformément à l’art. 18 du RGPD que le
            traitement des données à caractère personnel vous concernant soit
            limité.
          </li>
          <li>
            Le droit à l'effacement : vous avez en outre conformément à l’art.
            17 du RGPD le droit d’exiger de nous sous certaines conditions
            l'effacement des données à caractère personnel vous concernant.
          </li>
          <li>
            Le droit à la portabilité des données : Vous avez en outre
            conformément à l‘art. 20 du RGPD le droit, sous certaines conditions
            de recevoir les données à caractère personnel vous concernant que
            vous avez mises à disposition dans un format structuré, courant et
            lisible par machine et de les transférer facilement de chez nous
            vers un autre responsable de traitement.
          </li>
          <li>
            Le droit d’opposition : Vous avez en outre conformément à l‘art. 21
            du RGPD, le droit, sous certaines conditions, de vous opposer à un
            traitement de vos données à caractère personnel.
          </li>
          <li>
            Pour modifier vos données personnelles vous pouvez contacter notre
            DPO, à l’adresse mail suivante : dpo@cetim.fr
          </li>
        </ul>
        <br />
        <h4>Communication des données à des tiers</h4>
        <p class="text-justify">
          En principe, nous ne communiquons aucune information à caractère
          personnel à des tiers en dehors des finalités expliquées dans ce
          document. Le Cetim peut néanmoins transférer des données à caractère
          personnel à des prestataires ou à des sous-traitants notamment pour
          gérer des inscriptions, des abonnements, assurer le suivi du
          traitement d’une demande et pour administrer ses sites.
        </p>
        <p class="text-justify">
          Dans cette hypothèse, le Cetim peut confier à un tiers sous-traitant
          des données personnelles en vue d’un traitement pour le compte, sur
          instruction et sous l’autorité du responsable de traitement. L’article
          28 du RGPD qui impose la conclusion d’un contrat spécifique entre le
          sous-traitant et le responsable du traitement, le Cetim a mis en place
          les mesures nécessaires, impliquant des obligations renforcées pour le
          respect des droits des personnes physiques dont les données font
          l’objet d’un traitement. Cela implique :
        </p>
        <ul>
          <li>
            Une obligation de transparence et de traçabilité au travers d’un
            contrat ou un autre acte juridique précisant les obligations de
            chaque partie et reprenant les dispositions de l’article 28 du RGPD
          </li>
          <li>
            La prise en compte des principes de protection des données dès la
            conception et de protection de données par défaut
          </li>
          <li>Une obligation de garantir la sécurité des données traitées</li>
          <li>
            Un partage des responsabilités entre le sous-traitant et le
            responsable du traitement Si toutefois nous avons l’obligation
            légale de le faire ou suite à une décision de justice, nous
            transmettrons vos données aux autorités compétentes. Le Cetim ne
            transfère des données qu’à des sous-traitants localisés en France ou
            dans l’Union Européenne, des sous-traitants offrant le même niveau
            de protection des personnes physiques offert par le RGPD.
          </li>
        </ul>
        <br />
        <h4>Suppression des données et durée de stockage</h4>
        <p class="text-justify">
          Le Cetim ne conserve vos données à caractère personnel que pendant la
          durée strictement nécessaire afin de répondre aux finalités décrites
          précédemment, afin de respecter ses obligations légales,
          réglementaires et contractuelles et pour la défense de ses intérêts
          légitimes. <br />
          En principe, nous supprimons ou bloquons toujours vos données à
          caractère personnel lorsque le stockage perd sa raison d’être. Mais
          les données à caractère personnelles peuvent fait l’objet d’un
          stockage par ailleurs si cela est prévu par des prescriptions
          juridiques auxquelles nous sommes soumis par exemple relativement à
          l’obligation légale de conservation et de documentation. Dans un tel
          cas, nous supprimons ou bloquons vos données à caractère personnel
          après la fin des prescriptions correspondantes.
        </p>
        <h4>Stockage de données à caractère personnel</h4>
        <p class="text-justify">
          Vos données sont stockées par nos soins sur des serveurs
          particulièrement protégés, sur le territoire national ou de l’Union
          Européenne, offrant le même niveau de sécurité. Elles sont protégées
          par des mesures techniques et organisationnelles contre la perte, la
          destruction, l’accès, la modification ou la diffusion par des
          personnes non autorisées. L’accès à vos données n’est possible que
          pour un nombre limité de personnes autorisées. Celles-ci sont
          responsables de la gestion technique, commerciale ou rédactionnelle
          des serveurs. Vos données à caractère personnel sont transmises via
          internet sous forme codée. <br />
          Nous utilisons un codage SSL (Secure Socket Layer) pour la
          transmission des données.
        </p>
        <h4>Réclamations</h4>
        <p class="text-justify">
          Si vous êtes d’avis que le traitement de vos données à caractère
          personnel par nos soins n’est pas en conformité avec la présente
          déclaration de confidentialité ou avec les dispositions applicables en
          matière de confidentialité, vous pouvez introduire une réclamation
          auprès de notre délégué à la protection des données. Le délégué à la
          protection des données vérifiera alors la question et vous informera
          du résultat de la vérification. Vous avez en outre un droit de
          réclamation auprès d’une autorité de contrôle.
        </p>
        <h4>Délégué à la protection des données - CNIL</h4>
        <p class="text-justify">
          Vous pourrez contacter notre Délégué à la protection des données à
          l’adresse : <a href="mailto:dpo@cetim.fr">dpo@cetim.fr</a>
          <br />
          <br />
          Vous pouvez également faire cette demande par courrier à l'adresse
          suivante :
        </p>
        <p class="text-justify">
          <span class="font-weight-bold"
            >Cetim – Délégué à la Protection des Données</span
          >
          <br />
          52 avenue Félix Louat <br />
          CS 80067 60304 <br />
          SENLIS Cedex <br />
          Tél. : +33 970 821 680 <br />
          Mél : <a href="mailto:dpo@cetim.fr">dpo@cetim.fr</a>
        </p>
        <p class="text-justify">
          En cas de litige non résolu avec notre DPO, vous pouvez introduire une
          réclamation auprès de la Commission nationale de l’informatique et des
          libertés (CNIL), qui est l’autorité administrative indépendante
          chargée de veiller au respect de la réglementation sur la protection
          des données personnelles en France (<a
            href="https://www.cnil.fr/"
            target="_blank"
            >www.cnil.fr</a
          >).
        </p>
        <h2 class="text-h5 mb-2" style="color: #ca0538">COOKIES</h2>
        <h4>Quels sont les cookies que nous utilisons ?</h4>
        <p class="text-justify">
          Le Cetim est particulièrement attentif à vos attentes et nous
          souhaitons préserver la confiance que vous nous portez. Concernant les
          données personnelles que vous nous confiez, nous vous informons sur
          notre politique en matière de dépôt et d’utilisation des cookies
          depuis notre site «
          <a href="https://www.cetim.fr/" target="_blank">www.cetim.fr</a> »
          vers votre terminal de connexion. Les cookies sont de petits fichiers
          texte, image ou logiciel, qui sont placés et stockés sur votre
          ordinateur, votre smartphone ou tout autre appareil permettant de
          naviguer sur Internet, lorsque vous visitez un site Web. Très utiles,
          les cookies permettent à un site Internet de vous reconnaître, de
          signaler votre passage sur telle ou telle page et de vous apporter
          ainsi un service additionnel : amélioration de votre confort de
          navigation, sécurisation de votre connexion ou adaptation du contenu
          d’une page à vos centres d’intérêt. Les informations stockées par les
          cookies, pendant une durée de validité limitée, portent notamment sur
          les pages visitées, le type de navigateur que vous utilisez, votre
          adresse IP. Nous utilisons les cookies dans le strict but de faciliter
          votre navigation et vous fournir des fonctions utiles. Seul l’émetteur
          d'un cookie est susceptible de lire ou de modifier les informations
          qui y sont contenues. Par ailleurs, lors de sa consultation, notre
          site collecte, à partir des logiciels activés par votre propre
          terminal, des données sur la date, les pages consultées, le temps de
          consultation… ainsi que l'adresse informatique de votre ordinateur, le
          fournisseur d'accès, le moteur de recherche, le lien à l'origine de
          cette consultation. Cette collecte nous permet d'améliorer l'ergonomie
          de notre site. Nous ne revendons, ni diffusons les données collectées
          par cookies à des tiers. Vous trouverez ci-dessous la liste des
          cookies utilisés.
        </p>
        <p class="text-justify">
          Cookies strictement nécessaires au fonctionnement du site :
        </p>
        <v-data-table
          :headers="HCookies1"
          :items="ICookies1"
          hide-default-footer
          class="elevation-1"
        ></v-data-table>
        <br />
        <p class="text-justify">
          Cookies permettant les statistiques de mesures d’audience :
        </p>
        <h4 class="mb-2">Matomo</h4>
        <v-data-table
          :headers="HCookies2"
          :items="ICookies2"
          hide-default-footer
          class="elevation-1"
        ></v-data-table>
        <br />
        <h4 class="mb-2">Tarteaucitron</h4>
        <v-data-table
          :headers="HCookies3"
          :items="ICookies3"
          hide-default-footer
          class="elevation-1"
        ></v-data-table>
        <br />
        <p class="text-justify">
          Cookies tiers destinés à améliorer l’interactivité du site :
        </p>
        <h4>YouTube (hébergement de vidéos)</h4>
        <p class="text-justify">
          Via ces cookies, ce tiers collectera et utilisera également vos
          données de navigation pour son propre compte afin de proposer de la
          publicité ciblée et des contenus en fonction de votre historique de
          navigation. Pour plus d’informations, nous vous encourageons à
          consulter sa politique de confidentialité.
        </p>
        <h4>Wisepops</h4>
        <p class="text-justify">
          Via ces cookies, ce tiers nous permet de créer des pop-ups
          d’information à caractère institutionnel et de gérer leurs options
          d'affichage et de fermeture en contrôlant exactement où et quand les
          présenter. Cette fonctionnalité utilise des cookies tiers directement
          déposés par ce service. Pour plus d’informations, nous vous
          encourageons à consulter sa politique de confidentialité.
        </p>
        <h4>Comment paramétrer les cookies ?</h4>
        <p class="text-justify">
          Conformément à la réglementation, vous disposez d’un droit
          d’opposition et d’accès sur les données vous concernant. Vous pouvez
          vous opposer au dépôt de cookies statistiques en utilisant les
          paramètres appropriés de votre navigateur concernant les cookies, le
          mode navigation privée ou encore le paramétrage « Do Not Track » de
          votre navigateur. Selon votre navigateur, vous disposez des options
          suivantes : accepter ou rejeter les cookies de toute origine ou d’une
          provenance donnée ou encore programmer l’affichage d’un message vous
          demandant votre accord à chaque fois qu’un cookie est déposé sur votre
          terminal. Pour exprimer ou revenir sur vos choix, reportez-vous au
          menu d'aide ou à la rubrique dédiée de votre navigateur. A titre
          d’exemple vous pouvez obtenir plus d’informations sur les pages
          suivantes : <br />
          <a
            href="https://support.microsoft.com/fr-fr/windows/supprimer-et-g%C3%A9rer-les-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
            target="_blank"
            >Edge</a
          >
          <br />
          <a
            href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
            target="_blank"
            >Safari</a
          >
          <br />
          <a
            href="https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en"
            target="_blank"
            >Chrome</a
          >
          <br />
          <a
            href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur?redirectslug=Activer+et+d%C3%A9sactiver+les+cookies&redirectlocale=fr"
            target="_blank"
            >Firefox</a
          >
          <br />
          <a
            href="https://help.opera.com/en/latest/web-preferences/#cookies"
            target="_blank"
            >Opera</a
          >
          <br />
          <br />
          Pour les périphériques mobiles, vous pouvez consulter les liens
          suivants : <br />
          <a
            href="https://support.google.com/accounts/answer/61416?hl=fr&ref_topic=2373959"
            target="_blank"
            >Chrome</a
          >
          <br />
          <a href="https://support.apple.com/fr-fr/HT201265" target="_blank"
            >Safari</a
          >
          <br />
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      HCookies1: [
        {
          text: "Nom du cookie",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "name",
        },
        {
          text: "Fournisseur",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "fournisseur",
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "description",
        },
        {
          text: "Expiration",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "expiration",
        },
      ],
      ICookies1: [
        {
          name: "PHPSESSID",
          fournisseur: "cetim.fr",
          description:
            "Conserve la configuration des paramètres des Utilisateurs à travers les demandes de page",
          expiration: "Session",
        },
        {
          name: "rc::a",
          fournisseur: "google.com",
          description: "Utilisé pour distinguer les humains des robots",
          expiration: "Persistant",
        },
        {
          name: "rc::c",
          fournisseur: "google.com",
          description: "Utilisé pour distinguer les humains des robots",
          expiration: "Session",
        },
        {
          name: "test_cookie",
          fournisseur: "doubleclick.net",
          description:
            "Utilisé pour vérifier si le navigateur accepte les cookies",
          expiration: "1 jour",
        },
      ],
      HCookies2: [
        {
          text: "Nom du cookie",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "name",
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "description",
        },
        {
          text: "Expiration",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "expiration",
        },
      ],
      ICookies2: [
        {
          name: "_pk_id",
          description:
            "Ce cookie est utilisé pour enregistrer certains détails sur l'utilisateur, comme l'identifiant unique du visiteur.",
          expiration: "13 mois",
        },
        {
          name: "_pk_ses",
          description: "Il s'agit d'un cookie de courte durée utilisé pour stocker temporairement des données relatives à la visite.",
          expiration: "30 minutes",
        }
      ],
      HCookies3: [
        {
          text: "Nom du cookie",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "name",
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "description",
        },
        {
          text: "Expiration",
          align: "start",
          sortable: false,
          class: "text-subtitle-1 font-weight-bold black--text",
          value: "expiration",
        },
      ],
      ICookies3: [
        {
          name: "tarteaucitron",
          description:
            "Ce coockie stocke les préférences de consentement de lutilisateur. Il enregistre si l’utilisateur accepte ou refuse certains types de cookies.",
          expiration: "12 mois",
        }
      ],
    };
  },
};
</script>

